// ナレッジ機能の純関数（依存ゼロ）。UI(KnowledgeView) と script テストが共有する。
// Rust側 service/knowledge.rs::normalize_tags / list並びと挙動を揃える。

/** カンマ区切り文字列をタグ配列に分解（トリム・空要素除去）。 */
export function splitTags(tags: string): string[] {
  return tags
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean);
}

/**
 * タグ正規化（Rust側 normalize_tags と同仕様）:
 * トリム・空要素除去・大小無視の重複除去（最初の出現を維持）。
 */
export function normalizeTags(raw: string): string {
  const seen: string[] = [];
  for (const part of raw.split(",")) {
    const t = part.trim();
    if (!t) continue;
    if (!seen.some((s) => s.toLowerCase() === t.toLowerCase())) {
      seen.push(t);
    }
  }
  return seen.join(",");
}

/** 一覧に出ている全タグを重複なく収集（ソート済み）。 */
export function collectTags(items: Array<{ tags: string }>): string[] {
  const set = new Set<string>();
  for (const item of items) for (const t of splitTags(item.tags)) set.add(t);
  return [...set].sort();
}
